import type { AxiosRequestConfig } from 'axios'
import { apiRequest } from '@/lib/api/request'

export type ApiConfig = AxiosRequestConfig

export default class BaseApi {
  config: ApiConfig

  constructor(config: ApiConfig) {
    this.config = { baseURL: '', url: '', ...config }
  }

  async do<R = unknown>(rest: AxiosRequestConfig): Promise<R> {
    const res = await apiRequest<R>({
      ...this.config,
      ...rest,
      headers: {
        ...this.config.headers,
        ...rest.headers,
      },
    })
    return res.data as R
  }

  post<R = unknown>(config?: AxiosRequestConfig) {
    return this.do<R>({ ...config, method: 'POST' })
  }

  get<R = unknown>(config?: AxiosRequestConfig) {
    return this.do<R>({ ...config, method: 'GET' })
  }
}
